export default __webpack_public_path__ + "static/media/logo_black.03a9ba65.png";